import React from "react";
import { useNavigate } from "react-router-dom";
import {
     ContentRightWr,
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import SalesDataManagement from "./SalesDataManagement";

export default function SalesDataManagementWrapper() {
     const navigate = useNavigate();

     return (
          <>
               <MainLeftTitle title="Sales Data Management">
                    {/* <CreateButton
                         name="Create Incentive Campaign"
                          onClick={() => navigate("/app/incentive-data-manage/add")}
                    /> */}
               </MainLeftTitle>
               
               <SalesDataManagement/>
          </>
     );
}
